import axios from 'axios'
import { URL } from '../url'

export default async function getFaqs (email, password) {
  const response = await axios.get(URL + '/questions')
  return response
}
